import { storyblokEditable, renderRichText } from '@storyblok/react'
import Image from 'next/image'
import { getStoryblokImageDimensions, hasRichTextContent } from '@/lib/utils'
import { ImageGridItemStoryblok, ImageGridStoryblok } from '@/component-types-sb'

export default function ImageGrid({ blok }: { blok: ImageGridStoryblok }) {
    const images = blok.images || []
    const layout = blok.layout || 'auto'

    const getGridCols = () => {
        if (layout === 'full') return 'grid-cols-1'
        if (layout === 'half') return 'grid-cols-1 md:grid-cols-2'
        if (layout === 'third') return 'grid-cols-1 md:grid-cols-3'
        return images.length === 1 ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2'
    }

    if (images.length === 0) return null

    return (
        <section {...storyblokEditable(blok)} className="imageGrid max-w-[1200px] mx-auto p-5 md:p-10">
            {blok.heading && <h2 id={blok.heading}>{blok.heading}</h2>}
            <div className={`grid ${getGridCols()} gap-6`}>
                {images.map((item: ImageGridItemStoryblok, index: number) => {
                    const image = item.image
                    if (!image?.filename) return null
                    
                    const dimensions = getStoryblokImageDimensions(image.filename)
                    const width = image.width || dimensions?.width || 1200
                    const height = image.height || dimensions?.height || 800
                    const textContent = item.text
                        ? String(renderRichText(item.text as Parameters<typeof renderRichText>[0]) || '')
                        : ''
                    const hasText = hasRichTextContent(textContent)
                    
                    return (
                        <figure key={item._uid} className="flex flex-col" {...storyblokEditable(item)}>
                            <Image
                                src={image.filename}
                                alt={image.alt || ''}
                                width={width}
                                height={height}
                                className="w-full h-auto"
                                loading={index === 0 ? 'eager' : 'lazy'}
                            />
                            {hasText && (
                                <div className="prose text-sm p-2 md:max-w-[85%] mx-auto bg-white [&>*:last-child]:mb-0"
                                    dangerouslySetInnerHTML={{ __html: textContent || '' }} />
                            )}
                        </figure>
                    )
                })}
            </div>
        </section>
    )
}